import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'

export const EvidenceCellText = styled.p`
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${palette.neutral[900]};
`
